<bulb-share-panel [unitId]="unitId" [compositeUnit]="compositeUnit" [parentUnitId]="parentUnitId" [disableScroll]="disableScroll" #sharePanel></bulb-share-panel>

<ng-template #defaultToggleButton>
  <button #toggleElRefDefault class="aero-button" [disabled]="disabled">
      <svg-icon [fontSize]="'1.2em'" class="aero-button__icon" [key]="buttonIcon"></svg-icon>
      <span>{{ 'sharePanel.shareButton' | transloco }}</span>
  </button>
</ng-template>

<ng-container *ngTemplateOutlet="toggleButton || defaultToggleButton"></ng-container>
